module.exports = __webpack_public_path__ + "static/img/btn.360aa7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slots/btn.png
// module id = kE/t
// module chunks = 0